/**
 * ThemeChip — consistent multi-color theme badge used across all pages.
 * Uses dynamic color generation for consistent colors across themes.
 * Known themes get curated colors, new themes get auto-generated consistent colors.
 */

import { getThemeClasses, getThemeDotColor as getDotColor, isPreferredTheme } from "../utils/dynamicColors";
import { displayTheme } from "../utils/format";

// Re-export for backward compatibility
export { getThemeDotColor } from "../utils/dynamicColors";

export default function ThemeChip({ theme, size = "md", showNewIndicator = false }) {
  const cls = getThemeClasses(theme);
  const isNew = showNewIndicator && !isPreferredTheme(theme);
  const sizeClasses = size === "xs" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5";
  
  return (
    <span 
      className={`inline-flex items-center gap-1 rounded-full font-medium whitespace-nowrap ${sizeClasses} ${cls}`}
      title={isNew ? "New theme - auto-generated color" : undefined}
    >
      {displayTheme(theme)}
      {isNew && <span className="w-1 h-1 rounded-full bg-current opacity-50" />}
    </span>
  );
}

/**
 * ThemeDot — small colored dot for charts/legends
 */
export function ThemeDot({ theme, size = 8 }) {
  const color = getDotColor(theme);
  return (
    <span 
      className="inline-block rounded-full flex-shrink-0"
      style={{ width: size, height: size, backgroundColor: color }}
    />
  );
}
